import { CAlert } from "@coreui/react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

export const Alert = ({ data }) => {
  const dispatch = useDispatch();
  const alertdata = useSelector((state) => state?.notification);
  useEffect(() => {
    if (alertdata.isShow) {
      setTimeout(() => {
        dispatch({ type: "NOTIFICATION_DESTROY" });
      }, 3000);
    }
  });
  if (alertdata.isShow) {
    return (
      <CAlert
        fade
        color={alertdata?.type == "success" ? "info" : "danger"}
        closeButton
      >
        {alertdata?.data}
      </CAlert>
    );
  }
  return "";
};
